<template>
  <div class="col-12 col-sm-6 col-xl-3">
    <div class="stat-card" :class="gradientClass">
      <div class="card-content">
        <span class="card-label">{{ title }}</span>
        <h2 class="card-value">{{ value.toLocaleString() }}</h2>
        <span class="card-sub">{{ subTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: String,
  value: [Number, String],
  subTitle: String,
  gradientClass: String
});
</script>

<style scoped>
.stat-card {
  padding: 1.5rem;
  border-radius: 16px;
  color: white;
  min-height: 140px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  border: none;
}
.stat-card:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.15); }
.card-label { font-size: 0.9rem; opacity: 0.9; display: block; margin-bottom: 0.5rem; }
.card-value { font-size: 1.8rem; font-weight: 700; margin-bottom: 0.3rem; }
.card-sub { font-size: 0.75rem; opacity: 0.7; }

.bg-gradient-blue { background: linear-gradient(135deg, #5e60ce 0%, #4847d6 100%); }
.bg-gradient-cyan { background: linear-gradient(135deg, #4cc9f0 0%, #4361ee 100%); }
.bg-gradient-purple { background: linear-gradient(135deg, #b5179e 0%, #7209b7 100%); }
.bg-gradient-green { background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%); }
</style>
